import React, { useContext, useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../styles/styles.css";
import formsDataGuest from "../lib/formsDataGuest.json";
import CustomDivComponent from "../components/divComponent";
import {
  getisGlobal,
  getsherwinText,
  setUploadIds,
  setMQRIds,
  setTestResultFileIds,
  getMQRIds,
  getUploadIds,
  getTestResultFileIds,
  postRequest,
  getUser,
  setVisitId,
  getMandatoryData,
  validateEmail,
  getCompanyId,
  getVisitId,
  getVisitType,
  getFutureVisitFromSMDashboard,
  setFollowupYN,
  setDoctorName,
  setDoctorId,
  validateSSNArray,
  setLanguageId,
  getDoctorId,
  getPEmail,
  getPhone,
} from "../Services/DataMode";
import UserContext from "../components/context";
import { useNavigate } from "react-router-dom";
import ReactLoading from "react-loading";
import VisitHistory from "../components/VisitHistory";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import Parser from "html-react-parser";
import { set } from "date-fns";


function PrivateCreateVisit(props) {
  const [loading, setloading] = useState(false);
  const [visitTypes, setVisitTypes] = useState([{ name: "Select", id: "0" }]);
  const [countries, setCountries] = useState([{ name: "Select", id: "0", abbr: "", code: "" }]);
  const [states, setStates] = useState([{ name: "Select", id: "0" }]);
  // for job and region title
  const [jobTitle, setJobTitle] = useState([{ name: "Select", id: "0" }]);
  const [region, setRegion] = useState([{ name: "Select", id: "0" }]);
  const [unitedRentals, setUnitedRentals] = useState(false);
  const [hideRegion, setHideRegion] = useState("Job_region_Id");
  const [hideRegionValue, setHideRegionValue] = useState(false);
  const [searchURL, setSearchURL] = useState(false);
  const [showAdditionalEmail, setShowAdditionalEmail] = useState(true);
  const [languages, setLanguages] = useState([{ name: "Select", id: "0" }]);
  // console.log(languages)
  const [isFamilySelected, setIsFamilySelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [relationShips, setRelationShips] = useState([{ name: "Select", id: "0" }]);
  const [time, setTime] = useState([{ name: "Select", id: "0" }]);
  const [hideControl, setHidecontrol] = useState("DrugType_Id");
  const [hideClaim, setHideClaim] = useState("");
  const [hideMQR, setHideMQR] = useState(true);
  const [hideJC, setHideJC] = useState(true);
  const [loadSSNDocuemnts, setSSNForDocuments] = useState("");
  const context = useContext(UserContext);
  const [create, setCreate] = useState(false)
  const [createVisitText, setCreateVisitText] = useState("Start New Visit");
  const [payText, setPayText] = useState("Pay");
  const [isRemotePatient, setRemotePatient] = useState(false);
  //patient's email
  const [showPatientField, setShowPatientField] = useState(true);
  const [createParentvisit_id, setCreateParentvisit_id] = useState(0);
  const [date, setDate] = useState(0);
  const [abbr, setAbbr] = useState("US");
  const [code, setCode] = useState("+1");
  const [isStateEnable, setStateEnable] = useState(true);
  const [isUploadID_Mandatory_Field, setisUploadID_Mandatory_Field] = useState(false);
  const [sherwinText, setSherwinText] = useState("");
  const [claimEnable, setClaimEnable] = useState(true);

  /// for date
  const [newDOB, setNewDOB] = useState("");
  const [SSNValidation, setSSNValidation] = useState(false);
  let navigate = useNavigate();
  const [State_YN, setState_YN] = useState(true);
  const [isOpen, setisOpen] = useState(false);
  const handleShowDialog = (event) => { setisOpen(!isOpen) };
  const [documentsVisitID, setdocumentsVisitID] = useState("");
  const [values, setValues] = useState({});
  const [statesCopy, setStatesCopy] = useState([{ name: "Select", id: "0" }]);
  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const [Branch_YN, setBranch_YN] = useState(true);
  const [isbranchEnable, setbranchEnable] = useState(true);
  const [branches, setBranches] = useState([{ name: "Select", id: "0" }]);
  const [branchesCopy, setBranchesCopy] = useState([{ name: "Select", id: "0" }]);

  const [followupvisit_CompletedYN, setfollowupvisit_CompletedYN] = useState(false);
  const [iscreateVisit, isFromCreateVisit] = useState(true);
  const [clearData, setClearData] = useState(false)
  const [self, setSelf] = useState(true);
  const [followupYN, setFollowupYN] = useState(false);
  const [token, setToken] = useState("");
  const [showCard, setShowCard] = useState(true);

  // Payment function
  const [cardNumber, setCardNumber] = useState('');
  const [months, setMonth] = useState([{ name: "MM", id: "0" }]);
  const [years, setYears] = useState([{ name: "YYYY", id: "0" }]);
  const [cvv, setCvv] = useState('');
  const [response, setResponse] = useState(null);
  const [errors, setErrors] = useState({});

  const monthOptions = getMandatoryData("yearsandmonth_dropdown", "months");
  // console.log(monthOptions, "month");

  // Handle month change
  const handleMonthChange = (e) => {
    setMonth(e.target.value);
    // console.log(months, "Month VAlues");
  };

  const yearOptions = getMandatoryData("yearsandmonth_dropdown", "years");
  // console.log(yearOptions, "year");

  // Handle year change
  const handleYearChange = (e) => {
    setYears(e.target.value);
  };

  function handleFieldChangeSelectRadio(label) {
    if (label === "Self" && isFamilySelected) {
      setIsFamilySelected(false);
    }
    else if (label === "Family" && !isFamilySelected) {
      setIsFamilySelected(true);
    }
  }

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
    setValues({ ...values, FamilyId: e.target.value });
  };

  const handleDateChange = (date, name) => {
    setDate("");
    setValues({ ...values, [name]: date });
  };

  function handleFieldChange(event) {
    var name = event.target.name;
    // console.log(name)
    var value = event.target.value;
    // console.log(value)
    // console.log(event.target.name + " --> " + event.target.value);

    // console.log("hello document ", values);
    if (name === "IDCard_File_IDs" && value) {
      setloading(true);
      setValues({ ...values, IDCard_File_IDs: "" });
      setloading(false);
    }
    if (name == "Visit_Category_Type_Id") {
      getPurposes(value);
    }
    if (name == "NR_PhoneNumber") {
      setValues({ ...values, PhoneNumber: value });
      values.PhoneNumber = value;
    }
    if (name == "ssn" && value.length === 9) {
      setloading(true);
      // console.log("SSN validation", value);
      // console.log("1234567890", "validation");
      getSSNValidation(value);
    }
    else if (name == "ssn" && value.length !== 9) {
      setSSNForDocuments("");
    }
    if (name == "Country_Id") {
      countries.map((item) => {
        if (item.id == value) {
          setAbbr(item.abbr);
          setCode(item.code);
        }
      });
      branchStateEnable(value);
    }
    if (name == "date_of_birth") {
      setDate(value);
    }
    if (name == "date_of_injury") {
      setDate(value);
    }
    setValues({ ...values, [name]: value });
    // console.log(value, "handleChangeValues");
    // console.log(name, value);
  }

  function branchStateEnable(countryId) {
    postRequest(
      "ws_webrtc/Telemed.asmx/GetCountryCode",
      { sKey: getUser(), iCountryId: countryId },
      (response) => {
        // console.log("Branch_YN " + response.d.Branch_YN);
        // console.log("State_YN " + response.d.State_YN);
        setState_YN(response.d.State_YN);
        if (response.d.Branch_YN === true) {
          if (branchesCopy.length == 1) {
            setbranchEnable(false);
          } else {
            setbranchEnable(true);
          }
          setBranches(branchesCopy);
        }
        else {
          setbranchEnable(false);
          const branchArray = [];
          branchArray.push({ id: 0, name: "None" });
          setBranches(branchArray);
        }

        if (response.d.State_YN === true) {
          setStateEnable(true);
          setStates(statesCopy);
        } else {
          setStateEnable(false);
          const stateArray = [];
          stateArray.push({ id: 0, name: "None" });
          setStates(stateArray);
        }
      },
      context
    );
  }

  function branchStateEnable2(countryId) {
    postRequest(
      "ws_webrtc/Telemed.asmx/GetCountryCode",
      { sKey: getUser(), iCountryId: countryId },
      (response) => {
        // console.log("Branch_YN " + response.d.Branch_YN);
        // console.log("State_YN " + response.d.State_YN);
        setBranch_YN(response.d.Branch_YN);
        setState_YN(response.d.State_YN);
        if (response.d.Branch_YN === true) {
          if (branchesCopy.length == 1) {
            setbranchEnable(false);
          } else {
            setbranchEnable(true);
          }
        } else {
          setbranchEnable(false);
          const branchArray = [];
          branchArray.push({ id: 0, name: "None" });
          setBranches(branchArray);
        }

        if (response.d.State_YN === true) {
          setStateEnable(true);
        } else {
          setStateEnable(false);
          const stateArray = [];
          stateArray.push({ id: 0, name: "None" });
          setStates(stateArray);
        }
      },
      context
    );
  }

  useEffect(() => {
    setTestResultFileIds("");
    setMQRIds("");
    setUploadIds("");
    props.updatePage();

    if (getVisitType() != "Future") {
      setloading(true);
      setTimeout(() => { setloading(false) }, 3000);
    }

    postRequest(
      "ws_webrtc/Telemed.asmx/GetPatientFamilyList",
      { sKey: getUser() },
      (response) => {
        const familyArray = [{ id: 0, name: "Select" }];
        // console.log("list", response.d)
        for (var i = 0; i < response.d.length; i++) {
          familyArray.push({
            id: response.d[i].relationship_ID,
            name: response.d[i].relationship_name,
          });
        }
        setRelationShips(familyArray);
      },
      context
    );

    postRequest(
      "ws_webrtc/Telemed.asmx/GetPrivateVisit",
      { sKey: getUser() },
      (response) => {
        const newArray = [];
        // console.log("category", response.d);
        // newArray.push({ id: 0, name: "Select" });
        for (var i = 0; i < response.d.length; i++) {
          newArray.push({
            id: response.d[i].PrivateVisitType_Id,
            name: response.d[i].PrivateVisitType,
          });
        }
        setVisitTypes(newArray);
      },
      context
    );

    postRequest(
      "ws_webrtc/Telemed.asmx/GetCountries",
      { sKey: getUser() },
      (response) => {
        const countryArray = [];
        for (var i = 0; i < response.d.length; i++) {
          countryArray.push({
            id: response.d[i].Country_Id,
            name: response.d[i].Country_Name,
            abbr: response.d[i].Country_Abbr,
            code: response.d[i].Country_Code,
          });
        }
        setCountries(countryArray);
      },
      context
    );

    postRequest(
      "ws_webrtc/Util.asmx/populateDDL",
      { sKey: getUser(), sTableName: "tblStates" },
      (response) => {
        const stateArray = [];
        // console.log("States ", response.d);
        stateArray.push({ id: 0, name: "Select" });
        for (var i = 0; i < response.d.length; i++) {
          stateArray.push({ id: response.d[i].id, name: response.d[i].name });
        }
        setStates(stateArray);
        setStatesCopy(stateArray);
      },
      context
    );

    postRequest(
      "ws_webrtc/Util.asmx/populateDDL",
      { sKey: getUser(), sTableName: "tbltelemed_languages" },
      (response) => {
        const langArray = [];
        // console.log("Languages ", response.d);
        for (var i = 0; i < response.d.length; i++) {
          langArray.push({ id: response.d[i].id, name: response.d[i].name });
        }
        setLanguages(langArray);
      },
      context
    );

    postRequest(
      "ws_webrtc/Util.asmx/GetClientSpecific_MandatoryFields",
      { sKey: getUser(), iCompanyId: getCompanyId() },
      (response) => {
        setisUploadID_Mandatory_Field(response.d.isUploadID_Mandatory_Field);
        //  callMethod();
      },
      context
    );

    postRequest(
      "ws_webrtc/Telemed.asmx/GetTimeSlots",
      { sKey: getUser() },
      (response) => {
        const timeArray = [];
        // console.log("Time Slots ", response.d);
        for (var i = 0; i < response.d.length; i++) {
          timeArray.push({
            id: response.d[i].Time_Id,
            name: response.d[i].Time,
          });
        }
        setTime(timeArray);
      },
      context
    );

    callMethod();
    return setTestResultFileIds(""), setMQRIds(""), setUploadIds("")
  }, []);

  function callGetVisit() {
    // console.log("visit_id " + getVisitId());
    getVisitDetails();
    if (getVisitType() == "Future") {
      if (getFutureVisitFromSMDashboard() == "True") {
        setCreateVisitText("Continue");
      }
      else {
        setCreateVisitText("Update Future Visit");
      }
    }
    else {
      setCreateVisitText("Continue");
    }
  }

  function callMethod() {
    if (getVisitId() > 0) {
      setloading(true);
      setValues({ ...values, Future_Date: getMandatoryData("visitPage", "create_future_visit_for_today") ? new Date() : tomorrow });
      isFromCreateVisit(false)
      setTimeout(() => { callGetVisit() }, 2000);
    }
    else {
      setValues({
        branch_id: 0,
        first_name: "",
        last_name: "",
        ssn: "",
        state_id: 0,
        date_of_birth: subtractYears(new Date(), 13),
        date_of_injury: new Date(),
        patient_email: getPEmail(),
        rfv: "Telemedicine",
        company_name: "",
        contact_name: "",
        creditcard_id: 0,
        visit_id: 0,
        Visit_Category_Type_Id: 4,
        MQR_File_Ids: "",
        IDCard_File_IDs: "",
        CompanyId: getCompanyId() == null ? 0 : getCompanyId(),
        Test_Result_File_Ids: "",
        Number_Of_Sessions: 0,
        followup_YN: false,
        Visit_Type: "Regular",
        NR_PhoneNumber: "",
        // NR_PhoneNumber: getPhone(), // path phone number
        PhoneNumber: "",
        Country_Id: 1,
        Language_Id: 1,
        Address1: "",
        Address2: "",
        City: "",
        Zip_Code: "",
        Time_Id: 0,
        SelfPayVisit_YN: getisGlobal() == "PRIVATE" ? true : false,
        Dependent_YN: isFamilySelected ? true : false,
        FamilyId: 0,
      });
    }
  }

  function subtractYears(date, years) {
    date.setFullYear(date.getFullYear() - years);
    return date;
  }

  function getVisitDetails() {
    postRequest(
      "ws_webrtc/Telemed.asmx/getVisitDetails",
      { sKey: getUser(), iVisitId: getVisitId() },
      (response) => {
        // console.log(response.d.PhoneNumber, "getVisitDetails phone");
        // console.log(response.d.NR_PhoneNumber, "getVisitDetails nrp");
        // console.log(response.d.PhoneNumber.split("-")[1], "getVisitDetails phone1");
        // console.log(response.d.NR_PhoneNumber.split("-")[1], "getVisitDetails nrp1");
        // console.log(response, "getVisitDetails");
        setloading(true);
        getSSNValidation(response.d.ssn.replaceAll("-", ""));
        setNewDOB(response.d.date_of_birth);
        setCreateParentvisit_id(response.d.parentvisit_id);
        getPurposes(response.d.Visit_Category_Type_Id);
        visitTypes.selectedValue = response.d.Visit_Category_Type_Id;
        // console.log(response.d.Dependent_YN, "response.d.Dependent_YN");
        // console.log(response.d.relationship_name, "response.d.relationship_name");
        // console.log(response.d.relationship_ID, "response.d.relationship_ID");
        // console.log("hello hoe  +++++>>>+++ ajgfjgfk ");

        setValues({
          branch_id: response.d.branch_id || 0,
          first_name: response.d.first_name,
          last_name: response.d.last_name,
          ssn: response.d.ssn.replaceAll("-", ""),
          state_id: response.d.state_id,
          date_of_birth: new Date(response.d.date_of_birth),
          date_of_injury: new Date(response.d.date_of_injury),
          patient_email: response.d.patient_email,
          rfv: "Telemedicine",
          company_name: "",
          contact_name: "",
          creditcard_id: 0,
          visit_id: getVisitId(),
          parentvisit_id: response.d.parentvisit_id,
          //followup_visitId
          Visit_Category_Type_Id: response.d.Visit_Category_Type_Id,
          MQR_File_Ids: "",
          IDCard_File_IDs: response.d.IDCard_File_IDs,
          CompanyId: 0,
          Test_Result_File_Ids: "",
          Number_Of_Sessions: 0,
          followup_YN: response.d.parentvisit_id == 0 ? false : true,
          Visit_Type: response.d.parentvisit_id == 0 ? "Regular" : "Follow-up",
          NR_PhoneNumber: response.d.NR_PhoneNumber.split("-")[1],
          PhoneNumber: response.d.PhoneNumber.split("-")[1],
          Country_Id: response.d.Country_Id,
          Language_Id: response.d.Language_Id,
          Address1: response.d.Address1,
          Address2: response.d.Address2,
          City: response.d.City,
          Zip_Code: response.d.Zip_Code,
          SelfPayVisit_YN: response.d.SelfPayVisit_YN,
          Dependent_YN: response.d.Dependent_YN,
          relationship_name: response.d.relationship_name,
          relationship_ID: response.d.relationship_ID,

          Future_Date:
            response.d.Future_Date == ""
              ? getMandatoryData("visitPage", "create_future_visit_for_today")
                ? new Date()
                : tomorrow
              : response.d.Future_Date,
          Time_Id: response.d.Time_Id,
        });
        showCreditcard();
        setdocumentsVisitID(getVisitId());
        // Keep ssn-doc key empty so UploadPreview loads documents by visitId.
        setSSNForDocuments("");
        setCode(response.d.NR_PhoneNumber.split("-")[0]);
        response.d.parentvisit_id == 0 ? setFollowupYN("false") : setFollowupYN("true");

        if (response.d.Dependent_YN) {
          setIsFamilySelected(true);
          setSelectedOption(response.d.relationship_ID);
          setSelf(false);
        }
        else {
          setIsFamilySelected(false);
        }

        branchStateEnable2(response.d.Country_Id);
        setfollowupvisit_CompletedYN(response.d.followupvisit_completedYN);
        setTimeout(() => { setloading(false) }, 5000);
      },
      context
    );
  }

  function showCreditcard() {
    postRequest(
      "ws_webrtc/Telemed.asmx/GetSelfPayPayment_YN",
      { sKey: getUser(), iVisitId: getVisitId() },
      (response) => {
        // console.log(response.d.consultation_Yn, "Payment status")
        if (response.d.consultation_Yn) {
          setShowCard(false)
        }
        else {
          setShowCard(true)
        }
      },
      context
    );
  }

  function getPurposes(purpose_id) {
    postRequest(
      "ws_webrtc/Util.asmx/TelemedVisitsPurposesGet",
      { sKey: getUser(), iVisitTypeID: purpose_id },
      (response) => {
        var tempArray = [];
        tempArray.push({ id: 0, name: "Select" });
        for (var i = 0; i < response.d.length; i++) {
          tempArray.push({
            id: response.d[i].PurposeOfVisit_Id,
            name: response.d[i].PurposeOfVisit,
          });
        }
      },
      context
    );
  }

  const checkSSNPatternAndValidate = () => {
    const cleanedSSNPre = values.ssn ? values.ssn.replace(/\D/g, "") : "";
    if (cleanedSSNPre.length !== 9) {
      validate();
      return;
    }
    postRequest(
      "ws_webrtc/Telemed.asmx/GetSSNPatternCompanySpecificValidation",
      { sKey: getUser(), iCompanyId: getCompanyId() == null ? 0 : getCompanyId(), iCompanyBranchId: values.branch_id || 0 },
      (response) => {
        console.log(response, "ssn rsponse")
        let spattern = "";
        let validations = [];
        if (Array.isArray(response.d)) {
          validations = response.d.map((x) => x.Validation).filter(Boolean);
          console.log(validations, "validations")
          spattern = new RegExp(validations);
          console.log(spattern.toString(), "spattern")
        } else if (response.d && response.d.Validation) {
          validations = [response.d.Validation];
        }

        if (validations.length > 0) {
          const cleanedSSN = values.ssn ? values.ssn.replace(/\D/g, '') : '';

          const isValid = validations.every((pattern) => {
            let cleanedPattern = pattern;

            if (cleanedPattern && cleanedPattern.includes("\\\\")) {
              cleanedPattern = cleanedPattern.replace(/\\\\/g, "\\");
            }

            // console.log("Original pattern:", pattern);
            // console.log("Cleaned pattern:", cleanedPattern);
            // console.log("SSN to test:", cleanedSSN);

            try {
              const regex = new RegExp(cleanedPattern);
              const testResult = regex.test(cleanedSSN);
              console.log("Pattern:", cleanedPattern, "SSN:", cleanedSSN, "Result:", testResult);
              return testResult;
            } catch (error) {
              console.error("Regex error with pattern:", cleanedPattern, error);
              try {
                const regex = new RegExp(pattern);
                return regex.test(cleanedSSN);
              } catch (e) {
                console.error("Regex error with original pattern:", pattern, e);
                return false;
              }
            }
          });

          console.log(isValid, "isValid")
          if (isValid) {
            setSSNValidation(false);
            validate();
          } else {
            setSSNValidation(true);
            context.setUser(0, "Error", getMandatoryData("visitPage", "ssn_invalid_message"), "OK");
          }
        } else {
          validate();
        }
      },
      context
    );
  }

  const validate = () => {

    const newErrors = {};

    if (values.FamilyId == 0 && isFamilySelected) {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "Relationship"), "OK");
    }
    // First and last name validations
    else if (values.first_name.trim() == "") {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "firstname"), "OK");
    }
    else if (values.last_name.trim() == "") {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "lastname"), "OK");
    }
    else if (isUploadID_Mandatory_Field && getMandatoryData("PrivateVisitPage", "upload_id_card") != "" && getUploadIds() == "") {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "upload_id_card"), "OK");
    }
    else if (values.ssn && values.ssn.trim() == "") {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "ssn_textfieldmsg"), "OK");
    }
    else if (values.ssn.trim().length == 0) {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "ssn_textfieldmsg"), "OK");
    }
    else if (values.ssn && values.ssn.length != 9) {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "ssn_validation"), "OK");
    }
    else if (SSNValidation) {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "ssn_invalid_message"), "OK");
    }
    else if (values.ssn.length == 9 && SSNValidation) {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "ssn_invalid_message"), "OK");
    }
    // else if (values.ssn && getMandatoryData("PrivateVisitPage", "ssn_invalid_message") != "" && values.ssn.length == 9 &&
    //   !validateSSNArray(values.ssn, getMandatoryData("PrivateVisitPage", "ssn_invalid"))) {
    //   context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "ssn_invalid_message"), "OK");
    // }
    // NR Phone Number validation
    else if (values.NR_PhoneNumber.trim() == "") {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "phonenumber"), "OK");
    }
    else if (values.date_of_birth == "" || values.date_of_birth == null) {
      context.setUser(0, "Error", "Please select Date of Birth", "OK");
    }
    else if (values.date_of_injury == "" || values.date_of_injury == null) {
      context.setUser(0, "Error", "Please select Date of Injury", "OK");
    }
    else if (values.date_of_birth > subtractYears(new Date(), 13)) {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "dob_validation"), "OK");
    }
    else if (values.date_of_birth > values.date_of_injury) {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "dateofinjury_validation"), "OK");
    }
    // Patient email validation
    else if (values.patient_email != "" && !validateEmail(values.patient_email)) {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "patient_email_validation"), "OK");
    }
    // Address validation
    else if (getMandatoryData("PrivateVisitPage", "Address1") != "" && values.Address1.trim() == "") {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "Address1"), "OK");
    }
    else if (getMandatoryData("PrivateVisitPage", "Address2") != "" && values.Address2.trim() == "") {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "Address2"), "OK");
    }
    else if (getMandatoryData("PrivateVisitPage", "City") != "" && values.City.trim() == "") {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "City"), "OK");
    }
    // State validation if enabled
    else if (values.state_id == 0 && isStateEnable) {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "state"), "OK");
    }
    // Zip Code validation
    else if (values.Zip_Code.trim() == "") {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "zip_code"), "OK");
    }
    else if (cardNumber.trim() == "" && showCard) {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "CardNumberValidation"), "OK");
    }
    else if ((months == "0" || monthOptions.includes(months) == false) && showCard) {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "ExpiryMonthValidation"), "OK");
    }
    else if ((years == "0" || yearOptions.includes(years) == false) && showCard) {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "ExpiryYearValidation"), "ok");
    }
    else if ((cvv.trim().length != 0 && cvv.trim().length < 3) || cvv.trim().length > 4) {
      context.setUser(0, "Error", getMandatoryData("PrivateVisitPage", "CVVValidation"), "OK");
    }
    else {
      // Request to check if patient is locked
      postRequest(
        "ws_webrtc/Telemed.asmx/getLockPatient_YN",
        { sKey: getUser(), sSSN: values.ssn },
        (response) => {
          if (response.d.status) {
            context.setUser(1, "Info", getMandatoryData("PrivateVisitPage", "isPatientLocked"), "OK", false, "", () => { console.log(false); }, () => {
              navigate("/App/PrivateDashboard");
            });
            return;
          }
          else {
            // Check if there is a self-pay incomplete alert
            postRequest(
              "ws_webrtc/Telemed.asmx/SelfPayIncompleteAlert",
              { sKey: getUser() },
              (response) => {
                // console.log(response, "alert");

                var docName = response.d.Doc_Name;
                var array = ["Your Previous visit is yet to be completed by Provider ", "(" + docName + ")", ".  Do you want to create a new visit?"];

                // Check if self-pay visit is flagged
                if (response.d.SelfPayVisit_YN) {
                  // Show self-pay incomplete alert
                  context.setUser(1, "Info", array, "OK", true, "Cancel", () => {
                    // Action for Cancel
                  }, () => {
                    // Action for OK
                    if (getTestResultFileIds() == "") {
                      context.setUser(1, "Document's Info",
                        "Scanned copy of all Test results are not uploaded. Do you want to continue to next screen?", "OK", true, "Cancel",
                        () => { }, () => {
                          showCard ? handleTokenization() : createVisit("");
                        });
                    }
                    else {
                      // If no issues, proceed to create the visit
                      showCard ? handleTokenization() : createVisit("");
                    }
                  });
                }
                else if (getTestResultFileIds() == "") {
                  context.setUser(1, "Document's Info",
                    "Scanned copy of all Test results are not uploaded. Do you want to continue to next screen?", "OK", true, "Cancel",
                    () => { }, () => {
                      showCard ? handleTokenization() : createVisit("");
                    });
                }
                else {
                  // If no issues, proceed to create the visit
                  showCard ? handleTokenization() : createVisit("");
                }
              }
            );
          }
        }
      );
      // If errors exist, return false, otherwise true
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return false;
      }
      return true;
    }
  };


  function createVisit(receivedToken) {
    setloading(true);
    setLanguageId(values.Language_Id);
    var ssnnumber = values.ssn.replace(/(\d{3})(\d{2})(\d{4})/, "$1-$2-$3");
    var NRPhoneNo = code + "-" + values.NR_PhoneNumber;
    var data = values;
    data.date_of_birth = new Date(values.date_of_birth);
    data.ssn = ssnnumber;
    data.NR_PhoneNumber = NRPhoneNo;
    var phoneNo = code + "-" + values.PhoneNumber;
    data.PhoneNumber = phoneNo;
    data.Test_Result_File_Ids = getTestResultFileIds();
    data.IDCard_File_IDs = getUploadIds();
    data.MQR_File_Ids = getMQRIds();

    data.HR_Email =
      sherwinText == "" ? values.HR_Email : values.HR_Email + sherwinText;
    if (values.RemotePatient_YN == true && !values.PhoneNumber == "") {
      var phoneNo = code + "-" + values.PhoneNumber;
      data.PhoneNumber = phoneNo;
    }
    if (Branch_YN == false) {
      data.branch_id = 0;
    }
    if (State_YN == false) {
      data.state_id = 0;
    }
    if (values.parentvisit_id > 0) {
      if (values.parentvisit_id == values.visit_id) {
        if (searchURL) {
          data.followup_parentvisitId = values.visit_id;
        }
      }
      else {
        if (followupvisit_CompletedYN == true) {
          data.followup_parentvisitId = values.visit_id;
        }
        else {
          data.followup_visitId = values.visit_id;
        }
      }
    }

    if (getVisitType() == "Future" && getFutureVisitFromSMDashboard() == "False") {
      // console.log("Future " + JSON.stringify(data));
      postRequest(
        "ws_webrtc/Telemed.asmx/CreateFutureVisit",
        { sKey: getUser(), oFormFS: data },
        (response) => {
          // console.log(response.d.key);
          setloading(false);
          if (createVisitText == "Update Future Visit") {
            var array = ["Future Visit updated successfully for", data.first_name + " " + data.last_name, " ",];
          }
          else {
            var array = ["Future Visit created successfully for", data.first_name + " " + data.last_name, " ",];
          }
          context.setUser(2, "Success", array, "OK", false, "OK", null, () => {
            navigate("/App/FutureDashboard");
          });
        },
        context
      );
    }
    else {
      const paramas = data;
      if (createParentvisit_id > 0) {
        paramas.date_of_birth = moment(new Date(paramas.date_of_birth)).format("MM/DD/yyyy");
      }
      else {
        setValues({ date_of_birth: new Date(data.date_of_birth) });
      }
      // console.log("Hello ++++++++++++++++>>>", paramas);
      postRequest(
        "ws_webrtc/Telemed.asmx/createNewVisit",
        { sKey: getUser(), oFormFS: paramas },
        (response) => {
          // console.log(response.d.key);
          // console.log("testing for date of birth =====>", data.date_of_birth);
          const paymentToken = receivedToken;
          // console.log("Using Payment Token:", paymentToken);
          updateCreateVisitLog("Visit created with VisitID" + response.d.key);

          if (showCard) {
            postRequest(
              "ws_webrtc/Telemed.asmx/CreateCustomerProfileAndPaymentProfile",
              {
                sKey: getUser(),
                sVisitType: getVisitId() > 0 ? "Follow-up" : "Regular",
                iVisitId: response.d.key,
                paymentToken: paymentToken
              },
              (paymentResponse) => {
                // console.log("Customer profile and payment profile created successfully", paymentResponse);
                if (paymentResponse.d.status) {
                  // console.log("Customer profile and payment profile created successfully", paymentResponse);
                  setloading(true);

                  context.setUser(1, "Info", paymentResponse.d.message, "OK", false, "Cancel",
                    () => { }, () => {
                      // navigate("/App/PatientCallRoom");
                      if (getVisitId() > 0) {
                        getPreviousDoctor(response.d.key, data);
                        setVisitId(response.d.key);
                      }
                      else {
                        setloading(true);
                        setVisitId(response.d.key);
                        if (data.PurposeOfVisit_Id == 2) {
                          postRequest(
                            "ws_webrtc/Telemed.asmx/InsertProviderForVisitLog",
                            { sKey: getUser(), iVisitId: response.d.key, iDocId: 0 },
                            (response) => {
                              setDoctorId(0);
                              setDoctorName("Next Available");
                              navigate("/App/PatientCallRoom");
                            },
                            context
                          );
                        }
                        else {
                          if (getMandatoryData("PrivateVisitPage", "isSelectaProviderScreenVisible")) {
                            isproviderEngaged();
                          }
                          else {
                            navigate("/App/SelectProvider");
                          }
                        }
                      }
                    }
                  );

                  context.setUser(1, "Info", paymentResponse.d.message, "OK", false, "Cancel", () => { }, () => {
                    // navigate("/App/PatientCallRoom");
                    if (getVisitId() > 0) {
                      getPreviousDoctor(response.d.key, data);
                      setVisitId(response.d.key);
                    }
                    else {
                      setloading(true);
                      setVisitId(response.d.key);
                      if (data.PurposeOfVisit_Id == 2) {
                        postRequest(
                          "ws_webrtc/Telemed.asmx/InsertProviderForVisitLog",
                          { sKey: getUser(), iVisitId: response.d.key, iDocId: 0 },
                          (response) => {
                            setDoctorId(0);
                            setDoctorName("Next Available");
                            navigate("/App/PatientCallRoom");
                          },
                          context
                        );
                      }
                      else {
                        if (getMandatoryData("PrivateVisitPage", "isSelectaProviderScreenVisible")) {
                          isproviderEngaged();
                        }
                        else {
                          navigate("/App/SelectProvider");
                        }
                      }
                    }
                  }
                  );
                }
              },
              context
            );
          }
          else {
            if (getVisitId() > 0) {
              getPreviousDoctor(response.d.key, data);
              setVisitId(response.d.key);
            }
            else {
              setloading(true);
              setVisitId(response.d.key);
              if (data.PurposeOfVisit_Id == 2) {
                postRequest(
                  "ws_webrtc/Telemed.asmx/InsertProviderForVisitLog",
                  { sKey: getUser(), iVisitId: response.d.key, iDocId: 0 },
                  (response) => {
                    setDoctorId(0);
                    setDoctorName("Next Available");
                    navigate("/App/PatientCallRoom");
                  },
                  context
                );
              }
              else {
                if (getMandatoryData("PrivateVisitPage", "isSelectaProviderScreenVisible")) {
                  isproviderEngaged();
                }
                else {
                  navigate("/App/SelectProvider");
                }
              }
            }
          }
        },
        context
      );
    }
    setTestResultFileIds("");
    setMQRIds("");
    setUploadIds("");
  }

  function getSSNValidation(value) {
    setloading(false);
    // console.log("1393i848", getUser(), value);
    postRequest(
      "ws_webrtc/Util.asmx/GetSSNValidation_YN",
      { sKey: getUser(), sSSN: value },
      (response) => {
        setloading(true);
        if (response.d.status) {
          context.setUser(0, "Error", response.d.message, "OK");
          setSSNValidation(response.d.status);
          setSSNForDocuments("");
          setloading(false);
        }
        else {
          setSSNValidation(false);
          setSSNForDocuments(value);
        }
        setloading(false);
      },
      context
    );
  }

  function getPreviousDoctor(new_visit_id, data) {
    postRequest(
      "ws_webrtc/telemed.asmx/getProviderForPrevVisit_New",
      { sKey: getUser(), iVisitId: getVisitId() },
      (response) => {
        // console.log("Previous Visit ", JSON.stringify(response.d));
        var docId = response.d.doc_id;
        var docName = response.d.doc_name;
        var inConference = response.d.IsInConference;
        var inCheckout = response.d.IsInCheckout;
        //   setVisitId()
        setVisitId(new_visit_id);
        // console.log("dockk", docId);
        // console.log("docNa", docName);
        // console.log("inconferen", inConference);
        // console.log("incheck", inCheckout);
        setloading(false);
        if (docId == "0") {
          // console.log("provider1 Visit ID", getVisitId());
          if (getMandatoryData("PrivateVisitPage", "isSelectaProviderScreenVisible")) {
            isproviderEngaged();
          }
          else {
            navigate("/App/SelectProvider");
          }
        }
        else {
          // console.log("dockk", docId);
          showPreviousDocALert(docName, docId, new_visit_id, inConference, inCheckout);
        }
      },
      context
    );
  }

  function showPreviousDocALert(docName, docId, new_visit_id, in_conference, in_checkout) {
    var array = ["Initial visit was attended by ", docName, " Do you want the same provider for this call?",];
    context.setUser(1, "Info", array, "Yes", true, "No", () => {
      updateCreateVisitLog("Initial visit was attended by " + docName + " Do you want the same provider for this call?- No");
      setVisitId(new_visit_id);
      // console.log("provider2");
      if (getMandatoryData("PrivateVisitPage", "isSelectaProviderScreenVisible")) {
        isproviderEngaged();
        // console.log("docNameNo", docId);
      }
      else {
        navigate("/App/SelectProvider");
      }
    }, () => {
      if (getMandatoryData("PrivateVisitPage", "isSelectaProviderScreenVisible")) {
        insertDoc(docId);
        // console.log("docNameYes", docId);
        // isproviderEngaged();
      }
      else {
        navigate("/App/SelectProvider");
      }
    });
  }

  function getdocCheckoutStatus() {

    postRequest(
      "ws_webrtc/Telemed.asmx/getStateSpecificProvider",
      { sKey: getUser(), iVisitId: getVisitId() },
      (response) => {
        // console.log("get Doc checkoutResponse2", response.d);

        if ((response.d.IsInCheckout || response.d.IsInConference) && response.d.Doc_ID > 0) {
          context.setUser(1, "Info", getMandatoryData("select_provider", "all_engaged_message"), getMandatoryData("select_provider", "all_engaged_btn"),
            false, "", "", () => {
              navigate("/App/Dashboard");
              notifyEmail();
            }
          );
        } else {
          postRequest(
            "ws_webrtc/Telemed.asmx/IsProviderCheckoutState",
            { sKey: getUser(), iVisitId: getVisitId() },
            (checkoutResponse) => {
              // console.log("get Doc checkoutResponse1", checkoutResponse.d);
              if ((checkoutResponse.d.IsInCheckout || checkoutResponse.d.IsInConference) && response.d.Doc_ID > 0) {
                context.setUser(1, "Info", getMandatoryData("select_provider", "all_engaged_message"), getMandatoryData("select_provider", "all_engaged_btn"),
                  false, "", "", () => {
                    navigate("/App/Dashboard");
                    notifyEmail();
                  }
                );
              }
              else {
                insertDoc(response.d.Doc_ID);
                setDoctorId(response.d.Doc_ID);
              }
              // console.log(checkoutResponse, "che")
            }
          );
        }
      }
    );
  }

  function isproviderEngaged(item) {
    postRequest(
      "ws_webrtc/telemed.asmx/IsAllTelemedProvidersEngaged",
      { sKey: getUser(), iVisitId: getVisitId() },
      (response) => {
        // console.log(response.d, "get Doc status");
        if (response.d) {
          context.setUser(1, "Info", getMandatoryData("select_provider", "all_engaged_message"), "Ok", notifyEmail());
        }
        else {
          getdocCheckoutStatus(item);
        }
      },
      context
    );
  }

  function insertDoc(item) {
    // console.log("items", item);
    postRequest(
      "ws_webrtc/Telemed.asmx/InsertProviderForVisitLog",
      { sKey: getUser(), iVisitId: getVisitId(), iDocId: item },
      (response) => {
        setDoctorId(item);
        // console.log("docID", getDoctorId());
        if (response.d) {
          navigate("/App/PatientCallRoom");
        }
      },
      context
    );
  }

  function selectedPreviousDoctor(IsInConference, IsInCheckout, new_visit_id, docId, doc_name) {
    updateCreateVisitLog("Initial visit was attended by " + doc_name + " Do you want the same provider for this call?- Yes");
    if (IsInConference) {
      var array = ["Provider ", doc_name, " is not available. Please select OK for the next available provider",];
      context.setUser(1, "Info", array, "Cancel", true, "OK", () => {
        updateCreateVisitLog(doc_name + "Provider in conference , OK Clicked");
        setVisitId(new_visit_id);
        navigate("/App/PatientCallRoom");
      },
        () => {
          updateCreateVisitLog(doc_name + "Provider in conference , Cancel Clicked");
          setVisitId(new_visit_id);
          abortFollowUpVisit();
        });
    }
    else if (IsInCheckout) {
      var array = ["Provider ", doc_name, " is in check out. Please select OK for the next available provider",];
      context.setUser(1, "Info", array, "Cancel", true, "OK", () => {
        updateCreateVisitLog(doc_name + "Provider in checkout , OK Clicked");
        setVisitId(new_visit_id);
        navigate("/App/PatientCallRoom");
      },
        () => {
          updateCreateVisitLog(doc_name + "Provider in checkout , Cancel Clicked");
          setVisitId(new_visit_id);
          abortFollowUpVisit();
        });
    }
    else {
      setVisitId(new_visit_id);
      insertProviderForVisit(docId);
      setDoctorName(doc_name);
      setDoctorId(docId);
    }
  }

  function insertProviderForVisit(docId) {
    setloading(true);
    postRequest(
      "ws_webrtc/telemed.asmx/InsertProviderForVisitLog",
      { sKey: getUser(), iVisitId: getVisitId(), iDocId: docId },
      (response) => {
        setloading(false);
        // console.log("Previous Visit ", JSON.stringify(response));
        if (response.d) {
          navigate("/App/PatientCallRoom");
        }
      },
      context
    );
  }

  function abortFollowUpVisit() {
    setloading(true);
    postRequest(
      "ws_webrtc/WebRTC.asmx/cancelRTCSession",
      { sKey: getUser(), iVisitId: getVisitId() },
      (response) => {
        setloading(false);
        // console.log("Abort Visit ", JSON.stringify(response));
        navigate("/App/PrivateDashboard");
      },
      context
    );
  }

  function updateCreateVisitLog(data) {
    // console.log("updateCreateVisitLog ===>>>>>>>", data);
    setloading(true);
    postRequest(
      "ws_webrtc/Telemed.asmx/InsertTelemedCreateVisitLog",
      { sKey: getUser(), sLog_Detail: data },
      (response) => {
        setloading(false);
        // console.log("Abort Visit ", JSON.stringify(response));
      },
      context
    );
  }

  function notifyEmail(action) {
    postRequest(
      "ws_webrtc/Telemed.asmx/SendEmailToTelemedProviders",
      { sKey: getUser(), iVisitId: getVisitId() },
      (response) => {
        // console.log(response, "trigger1");
      },
      context
    );
  }

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://jstest.authorize.net/v1/Accept.js";
    script.async = true;
    document.body.appendChild(script);
    // console.log('Accept.js script has been added to the page.');
  }, []);


  const handleTokenization = (event) => {

    const month = months;
    const year = years;

    const cardData = {
      cardNumber: cardNumber,
      month: month,
      year: year,
      cardCode: cvv,
    };

    // console.log('Expiration date split into month and year:', month, year);
    // console.log('Card data:', cardData);

    if (window.Accept && typeof window.Accept.dispatchData === 'function') {

      postRequest(
        "ws_webrtc/Telemed.asmx/GetAurhorizedPaymentGatewayDetails",
        { sKey: getUser() },
        (response) => {
          // console.log('Received response from GetAurhorizedPaymentGatewayDetails:', response);
          const { LoginId, ClientKey } = response.d;

          // Set authData with received values
          const authData = {
            clientKey: response.d.ClientKey, // Replace with actual client key
            apiLoginID: response.d.LoginId, // Replace with actual API Login ID
          };
          // console.log('authData:', authData);
          const authdemo = { ClientKey, LoginId };
          // console.log('authdemo:', authdemo);
          // console.log('cardData:', cardData);

          window.Accept.dispatchData(
            { authData, cardData },
            (response) => {
              handleResponse(response);
            },
            (error) => {
              handleError(error);
            }
          );

        },
        context
      );
    }
    else {
      console.error('Accept.js is not loaded correctly.');
      const errorMessage = response.messages.message[0].text;
      context.setUser(0, "Error", errorMessage, "OK");
    }
  };

  const handleResponse = (response) => {
    // console.log('Response:', response);
    // console.log("resultCode", response.messages.resultCode);

    if (response.messages.resultCode == "Error") {
      const errorMessage = response.messages.message[0].text;
      // console.log("ErrorMesage", errorMessage);
      context.setUser(0, "Error", errorMessage, "OK");
      setResponse({
        success: false,
        error: errorMessage,
      });
      return;
    }
    else {
      if (response.messages.resultCode === 'Ok') {
        const receivedToken = response.opaqueData.dataValue;
        // console.log('Token received:', receivedToken);
        setToken(receivedToken);
        postRequest(
          "ws_webrtc/Telemed.asmx/GetSelfPayPrice",
          { sKey: getUser(), sVisitType: getVisitId() > 0 ? "Follow-up" : "Regular" },
          (response) => {
            // console.log(response, "regularORfollwup");
            context.setUser(1, "Info", response.d.message, "Yes", true, "No", () => { }, () => {
              createVisit(receivedToken);
              setloading(true);
            })
          }
        )
        setResponse({ success: true, token: token });
      }
    }
  };

  const handleError = (error) => {
    context.setUser(0, "Error", error.messages.message, "OK")
    console.error('Error:', error);
    setResponse({
      success: false,
      error: error.messages.message[0].text,
    });
  };

  return (
    <>
      <div className="h-100 col-12 p-2">
        <div className="row">
          <div className="col-md-12 col-lg-12 col-xs-12 col-sm-12">
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xs-12 col-sm-12">
                <div className="contentbody">
                  <div className="row px-3 mb-2">
                    <div style={{ height: 10 }}></div>
                    <div style={{ display: "flex" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 20, fontWeight: "bold" }}>
                        {["Self", "Family"].map((label) => (
                          <label key={label} className="custom-radio">
                            <input style={{ marginRight: "25px", fontWeight: "bold", accentColor: "green", fontSize: 10, marginRight: 5 }}
                              type="radio"
                              value={label}
                              defaultChecked={label === "Self"}
                              disabled={self ? (followupYN && label === "Family") : (followupYN && label === "Self")}
                              checked={(label === "Self" && !isFamilySelected) || (label === "Family" && isFamilySelected)}
                              onChange={() => handleFieldChangeSelectRadio(label)}
                              onMouseEnter={(e) => (e.target.style.color = "green")}
                              onMouseLeave={(e) => (e.target.style.color = "green")}
                            />
                            <span className="custom-radio-mark" style={{ borderColor: "green" }}></span>
                            {label}
                          </label>
                        ))}
                      </div>
                    </div>
                    <div>
                      <p style={{ marginBottom: 10, fontStyle: "italic" }}>
                        <i>(Please select "Family" only if creating the visit for Family members)</i>
                      </p>
                    </div>

                    {isFamilySelected && (
                      <div>
                        <label style={{ paddingLeft: 5, color: "black", fontSize: "16px", fontWeight: "bold", color: "grey" }}>
                          {Parser(getMandatoryData("PrivateVisitPage", "RelationShipLbl"))}
                        </label>
                        <div className="row px-2">
                          <select
                            id="dropdown"
                            value={selectedOption}
                            // onChange={(e) => setSelectedOption(e.target.value)}
                            onChange={handleChange}
                            disabled={followupYN ? isFamilySelected : !isFamilySelected}
                            style={{ background: "#E2E2E2", height: 30, padding: 0 }}
                          >
                            {relationShips.map((option, index) => (
                              <option key={index} value={option.id}>
                                {option.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div style={{ marginBottom: showCard ? 20 : 70 }}>
                  <CustomDivComponent
                    data={formsDataGuest.PatientInfo}
                    visitTypes={visitTypes}
                    visitCategoryTypeData={visitTypes}
                    countryValue={countries}
                    branchValue={showCard ? "" : ""}
                    stateValue={states}
                    languageValue={languages}
                    // paymentValue={payments} // Ensure payments are passed correctly
                    timeValue={time}
                    hideControl={hideControl}
                    hideClaim={hideClaim}
                    hideMQR={hideMQR}
                    hideJC={hideJC}
                    loadSSNDocuemnts={loadSSNDocuemnts}
                    onFieldChange={handleFieldChange}
                    loadValues={values}
                    datePickerChange={handleDateChange}
                    remotePhoneNo={values.PhoneNumber}
                    countryAbbr={abbr}
                    sherwinText={sherwinText}
                    documentsVisitID={documentsVisitID}
                    isShowPatientEmail={showPatientField}
                    jobTitleValue={jobTitle}
                    regionValue={region}
                    hideRegion={hideRegion}
                    hideRegionValue={hideRegionValue}
                    unitedRentals={unitedRentals}
                    isShowAdditionalEmail={showAdditionalEmail}
                  />
                </div>

                {showCard && (
                  <form>
                    <div style={{ border: '1px solid black', marginBottom: 90 }} >
                      <div class="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ width: '100 %' }}>
                          <div class="fieldHeader" >
                            <label>Payment Info</label>
                          </div>
                          <div style={{ height: 8 }}></div>
                          <div style={{ marginLeft: 15, marginRight: 15, width: '100 %' }} >
                            <div>
                              <label style={{ paddingLeft: 5, color: 'black', fontSize: '16px', fontWeight: 'bold', color: 'grey' }}>
                                {Parser(
                                  getMandatoryData("PrivateVisitPage", "CardNumberLbl")
                                )}
                                {/* Enter Card Number <span style={{ color: 'red' }}>*</span> : */}
                              </label>
                              {/* <button style={{ border: "none", marginLeft: "10px", color: 'grey', backgroundColor: 'white', fontWeight: 'bold' }}>New</button> */}
                              {/* <button style={{ border: "none", marginLeft: "10px", color: 'grey', backgroundColor: 'white', fontWeight: 'bold' }}>Edit</button> */}
                            </div>

                            <div className="input-container" >
                              <input
                                type="text"
                                id="cardNumber"
                                class="form-control"
                                value={cardNumber}
                                onChange={(e) => setCardNumber(e.target.value)}
                                onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                required
                                placeholder="Enter Card Number"
                              />
                            </div>

                            <div className="input-container" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                              <div style={{ width: '30%' }}>
                                <label style={{ paddingLeft: 5, color: 'black', fontSize: '16px', fontWeight: 'bold', color: 'grey' }}>
                                  {Parser(getMandatoryData("PrivateVisitPage", "MMYYLbl"))}
                                </label>
                                <div className="row px-2">
                                  <select
                                    id="dropdown"
                                    value={months}
                                    onChange={handleMonthChange}
                                    style={{ background: "#E2E2E2", height: 35, padding: 0 }}
                                  >
                                    {monthOptions.map((month, index) => (
                                      <option key={index} value={month}>
                                        {month}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              <div style={{ width: '30%' }}>
                                <label style={{ paddingLeft: 5, color: 'black', fontSize: '16px', fontWeight: 'bold', color: 'grey' }}>
                                  {Parser(getMandatoryData("PrivateVisitPage", "YYYYLbl"))}
                                </label>
                                <div className="row px-2">
                                  <select
                                    id="dropdown"
                                    value={years}
                                    onChange={handleYearChange}
                                    required
                                    style={{ background: "#E2E2E2", height: 35, padding: 0, width: "100%" }}
                                  >
                                    {yearOptions.map((year, index) => (
                                      <option key={index} value={year}>
                                        {year}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              <div style={{ width: '30%' }}>
                                <label style={{ paddingLeft: 5, color: 'black', fontSize: '16px', fontWeight: 'bold', color: 'grey' }}>
                                  {Parser(getMandatoryData("PrivateVisitPage", "cvvLbl"))}
                                </label>
                                <input
                                  type="text"
                                  id="cvv"
                                  className="form-control"
                                  value={cvv}
                                  onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, ""); // Allow only numbers
                                    if (value.length <= 3) {
                                      setCvv(value); // Set the CVV if it's 3 digits or less
                                    }
                                    else if (value.length <= 4) {
                                      setCvv(value);
                                    }
                                  }}
                                  required
                                  placeholder="CVV"
                                  style={{ width: "100%" }}
                                />
                              </div>
                            </div>

                            {/* <button type="submit" disabled={isButtonDisabled}
                             onClick={handleTokenization}
                             style={{
                               justifyContent: "center",
                               alignItems: "center",
                               alignContent: "center",
                               fontSize: 16,
                               borderRadius: 9,
                               padding: "10px 30px",
                               fontWeight: "bold",
                               color: "#ffffff",
                               backgroundColor: buttonBgColor ? "#D92A28" : "#808080",
                               border: "#ffffff",
                               marginLeft: "45%",
                             }}>
                             {payText}
                           </button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="fixed-bottom">
          <div className="col-md-12 col-lg-12 col-xs-12 col-sm-12 d-flex justify-content-center">
            <div className="col-md-6 col-lg-6 col-xs-6 col-sm-6 bg-white d-flex justify-content-center">
              <button onClick={checkSSNPatternAndValidate}
                style={{
                  justifyContent: "center", alignItems: "center", alignContent: "center", fontSize: 16, borderRadius: 9, padding: "10px 30px", fontWeight: "bold",
                  color: "#ffffff", backgroundColor: "#D92A28", border: "#ffffff"
                }}
                variant="primary"
                type="submit"
              >
                {createVisitText}
              </button>
            </div>
          </div>
        </div>

        {loading && (
          <div style={{
            position: "fixed", left: "50%", top: "50%", transform: "translate(-50%, -50%)", height: "100%", width: "100%", display: "flex", flexDirection: "column",
            justifyContent: "center", alignItems: "center"
          }}
          >
            <ReactLoading type={"spin"} color={"#ff0000"} height={"5%"} width={"5%"} />
          </div>
        )}
      </div>

      {isOpen && (
        <Modal show={true} onHide={() => { handleShowDialog() }}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <VisitHistory />
          </Modal.Body>
        </Modal>
      )}
    </>

  );
};
export default PrivateCreateVisit;
